<template>
	<div class="all">
		<b-container fluid="sm" class="mt-5 nophone">
			<b-row align-h="center" >
				<b-col class="center-box r-left " md-push="3" align-v="center"  cols="12" md="5" lg="6" xl="7">
					<img v-for="(list,index) in data.contentImg" :key="index"  class="img-left" :src="$store.state.url+list" alt="" /></b-col>
				<b-col class="center-box r-right" md-pull="9" align-v="center" cols="12" md="7" lg="6" xl="5">
					<div class="detail">
						<p class="detail-name">{{data.name}}</p>
						<div class="gift-packs">
							<div :style="{border:'1px '+data.color+' solid',color:data.color}">
								<img v-if="type!=4 && type!=5 " :src="data.icon" alt="" />
								{{data.information}}
							</div>
					 	<img v-if="type!=4 && type!=5 " :src="$store.state.url+data.freeimg" alt="" />
						</div>
						<p class="detail-price">
							<span :style="{color:data.color}"><span :style="{color:data.color,fontSize:'18px'}">¥ </span> {{data.price}}</span>
							<span>原价¥{{data.originalPrice}}</span>
							<span>{{data.time}}</span>
						</p>
						<div class="scan">
							<img src="../../images/adviserwechat.png" alt="" />
							<img src="../../images/scan-code.png" alt="" />
						</div>
						<div class="step">
							<p>在线学习只需3步</p>
							<div class="step-content">
								<div>
									<img src="../../images/car.png" alt="" />
									购买课程
								</div>
								<p>选择自己感兴趣额课程，点击【立即报名】扫描弹出的二维码即可购买课程。</p>
							</div>
							<div class="step-content">
								<div>
									<img src="../../images/download.png" alt="" />
									下载客户端
								</div>
								<p>
									成功购买课程后，请及时下载【嗡嗡雅思AI课】客户端，查看开课时间及课程内容，购课手机号即为登录账号。
									<span><a href="https://app.honeybee-edu.com/html/download.html">立即下载</a></span>
								</p>
							</div>
							<div class="step-content">
								<div>
									<img src="../../images/video.png" alt="" />
									轻松上课
								</div>
								<p>在APP【我的课程】中查看每日课程，可在当天任意时间学习，专属辅导老师每天14至21点对所学内容进行点评和拓展，所学课程可永久回看。</p>
							</div>
						</div>
					</div>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
export default {
	name: 'App',
	data() {
		return {
			data:"",
			type:"",
			url:"",
		};
	},
	created() {
		this.type= sessionStorage.getItem('type');

		console.log(this.$store.state.courseDetails)
		this.data= this.$store.state.courseDetails[this.type];
		console.log(JSON.stringify(this.data));

	},
	methods: {
		back() {
			this.$router.push('/');
		},
		go() {
			this.$router.push('/cet');
		}
	}
};
</script>

<style>
	.r-left{
		order: 2;
	}
	.r-right{
		order: 1;
	}

	.all{
		width: 100%;
		overflow: hidden;
	}
	.img-left{
		width: 100%;
	}
.step-content p {
	margin-top: 0.8rem;
	font-weight: 400 !important;
	font-size: 0.7rem !important;
	font-weight: 400 !important;
	color: #898989 !important;
}

.step-content img {
	width: 1rem;
	height: 0.92rem;
	margin-right: 0.5rem;
}
.step-content {
	font-size: 0.87rem;
	font-weight: bold;
	color: #000000;
}
.step p {
	font-size: 1rem;
	font-weight: 400;
	color: #000000;
	font-weight: bold;
	margin-left: 1.54rem;
}
.step {
	width: 19.5rem;
	border: 1px solid #e5e5e5;
	border-radius: 0.625rem;
	padding: 1.75rem 1rem;
}
.scan {
	display: flex;
}
.scan img:nth-child(2) {
	display: block;
	width: 6rem;
	height: 1.3rem;
	margin-left: 1.25rem;
	margin-top: 6.375rem;
}
.scan img:nth-child(1) {
	display: block;
	width: 7.5rem;
	height: 7.5rem;
	margin: 1.875rem 0 1.875rem 0rem;
}
.detail-price {
	display: flex;
	flex-wrap: wrap;
	margin-top: 1.075rem;
}
.detail-price span:nth-child(3) {
	font-size: 0.8125rem;
	color: #c6c6c6;
	margin-top: 0.825rem;
	display: block;
	margin-left: 0.8rem;
}
.detail-price span:nth-child(2) {
	font-size: 0.8125rem;
	color: #c6c6c6;
	margin-top: 0.825rem;
	display: block;
	text-decoration: line-through;
	margin-left: 1.875rem;
}
.detail-price span:nth-child(1) {
	font-size: 1.7625rem;
	font-weight: bold;
	color: #4aa297;
}
.gift-packs img {
	height: 2rem;
	margin-left: 1.3375rem;
}
.gift-packs div {
	border: 1px solid #4aa297;
	border-radius: 0.3125rem;
	color: #4aa297;
	font-size: 0.875rem;
	padding: 0.3125rem 0.325rem;
	font-weight: bold;
	height: 2rem;
		margin-bottom: 1.075rem;
}
.gift-packs div img {
	width: 1rem;
	height: 1rem;
	margin-top: 0.1075rem;
	margin-right: 0.3125rem;
	margin-left: 0.225rem;
}
.gift-packs,
.gift-packs div {
	display: flex;
	flex-wrap: wrap;
}

.detail-name {
	font-size: 1.25rem;
	font-weight: bold;
}
.detail {
	width: 100%;
//	position: fixed;
//	top: 10.5rem;
//	left: 65%;
	text-align: left;
}
.mt-6 {
	margin-top: 3rem !important;
}
.mt-8 {
	margin-top: 5rem !important;
}
.mt-10 {
	margin-top: 7rem !important;
}

@media (min-width: 576px) {
	.r-left{
		order: 1;
	}
	.r-right{
		order: 2;
	}
	.detail-price span:nth-child(3) {
		margin-left: 3.8rem;
	}
	.scan img:nth-child(1) {
		margin: 1.875rem 0 1.875rem 2rem;
	}

}

@media (min-width: 768px) {
	.gift-packs img {
		margin-top: 0.125rem;
	}
	.detail-price span:nth-child(3) {
		margin-left: 4.8rem;
	}
	.scan img:nth-child(1) {
		margin: 1.875rem 0 1.875rem 4rem;
	}
}

@media (min-width: 992px) {
	.r-left{
		order: 1;
	}
	.r-right{
		order: 2;
	}
	.gift-packs img {
		margin-top: 0.125rem;
	}
	.detail-price span:nth-child(3) {
		margin-left: 5.8rem;
	}
	.scan img:nth-child(1) {
		margin: 1.875rem 0 1.875rem 6rem;
	}
}


@media (min-width: 1200px) {

	.r-left{
		order: 1;
	}
	.r-right{
		order: 2;
	}
	.gift-packs img {
		margin-top: 0.125rem;
	}
	.detail-price span:nth-child(3) {
		margin-left: 6.8rem;
	}
	.scan img:nth-child(1) {

		margin: 1.875rem 0 1.875rem 6rem;
	}
}

</style>



// WEBPACK FOOTER //
// src/components/coursedetails/coursedetails.vue